export enum TileLayerHiDpiMode {
  SHOW_NEXT_ZOOM_LEVEL = 'showNextZoomLevel',
  SUBSTITUTE_LAYER_SHOW_NEXT_ZOOM_LEVEL = 'substituteLayerShowNextZoomLevel',
  SUBSTITUTE_LAYER_TILE_PIXEL_RATIO_ONLY = 'substituteLayerTilePixelRatioOnly',
}
